var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeMapChartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7571 15.8496H1V27.9998H13.7571V15.8496Z",
    fill: "#BEBAD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8555 1H19.127V3.70004H27.8555V1Z",
    fill: "#BEBAD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8555 4.37305H19.127V10.4481H27.8555V4.37305Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8567 23.9492H23.8281V27.9993H27.8567V23.9492Z",
    fill: "#BEBAD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1568 23.9492H15.0996V27.9993H23.1568V23.9492Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.925 1H1V8.08761H13.925V1Z",
    fill: "#BEBAD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H1V15H14V9Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4568 1H15.0996V10.4501H18.4568V1Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8568 11.7988H15.0996V23.274H27.8568V11.7988Z",
    fill: "#BEBAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeMapChartWhite);
export default __webpack_public_path__ + "static/media/tree-map-chart-white.ec708d29ac235d76a4440b153171fff9.svg";
export { ForwardRef as ReactComponent };